import Vue from 'vue'
import Buefy from 'buefy'

import TractionHomeApp from './App.vue'


Vue.use(Buefy,{
    defaultIconPack: 'fas',
})
Vue.use(TractionHomeApp)

if (document.getElementById("tractionHomeApp")){
    new Vue({
        render: h=>h(
            TractionHomeApp,{
                props:{
                    staticUrl: document.getElementById("tractionHomeApp")
                        .getAttribute('static-url'),
                    postUrl: document.getElementById('tractionHomeApp')
                        .getAttribute('post-url')
                }
            }
        )
    }).$mount("#tractionHomeApp")
}
